// extracted by mini-css-extract-plugin
module.exports = {"time":"Time_time__ch_bV","narrow":"Time_narrow__o1qXY","green":"Time_green___RWjG","red":"Time_red__0PWgI"};